// Aturan murni menu Akun Admin & "Lupa Kata Sandi?" (diuji di akunAdmin.test.js).

// Judul & satu-satunya isi dialog "Lupa Kata Sandi?" (tanpa formulir/email sejak Okt 2026).
export const JUDUL_LUPA_SANDI = "Lupa Kata Sandi?";
export const PESAN_LUPA_SANDI = "Jika Anda lupa kata sandi, silakan hubungi UFP RSCM.";

// Tombol reset per baris akun (cermin server: reset-password = Super Admin, bukan diri sendiri;
// send-reset-link = Super Admin, hanya ke akun Super Admin lain).
export function aksiResetAkun(saya, target) {
    const superAdmin = saya?.role === "super_admin";
    const diriSendiri = saya?.id === target?.id;
    return {
        sandiSementara: superAdmin && !diriSendiri,
        linkEmail: superAdmin && !diriSendiri && target?.role === "super_admin",
    };
}

// Ubah email akun (perbaikan salah ketik) -- cermin PUT /users/{id}/email: hanya Super Admin, bukan akun
// sendiri, dan hanya akun Admin UFP/Prodi/Koas/Instalasi (email Super Admin tidak diubah lewat fitur ini).
export const PERAN_UBAH_EMAIL = ["admin_ufp", "admin_prodi", "admin_koas", "admin_instalasi"];
export const bisaUbahEmail = (saya, target) =>
    saya?.role === "super_admin" && saya?.id !== target?.id && PERAN_UBAH_EMAIL.includes(target?.role);

export const rapikanEmail = (v) => String(v ?? "").trim().toLowerCase();

// Pemeriksaan ringan di formulir (server tetap memeriksa format & keunikan). null = boleh lanjut.
export function periksaEmailBaru(lama, baru, konfirmasi) {
    const b = rapikanEmail(baru);
    if (!b) return "Email baru wajib diisi.";
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(b)) return "Format email baru tidak valid.";
    if (b !== rapikanEmail(konfirmasi)) return "Konfirmasi email tidak sama dengan email baru.";
    if (b === rapikanEmail(lama)) return "Email baru sama dengan email sekarang.";
    return null;
}

// Modul Admin Koas (Okt 2026) -- cermin create_user/update_user: prodi_id hanya disimpan utk Admin Prodi (prodinya)
// & Admin Koas (Modul = prodi berjenjang Koas); peran lain tidak mengirimnya.
export const PERAN_DENGAN_PRODI = ["admin_prodi", "admin_koas"];
export const prodiIdKirim = (form) => (PERAN_DENGAN_PRODI.includes(form.role) ? form.prodi_id || null : null);
export const modulKoasPilihan = (prodi) => (prodi || []).filter((p) => p.jenjang === "Koas");

// Modul wajib utk akun BARU Admin Koas & akun yg diganti menjadi Admin Koas; akun Admin Koas lama tanpa modul boleh
// tetap kosong (melihat semua modul). null = boleh lanjut.
export function periksaModulAkun(form, editing) {
    if (form.role !== "admin_koas" || form.prodi_id) return null;
    if (editing?.role === "admin_koas") return null;
    return "Pilih modul";
}

// Akun Admin Koas lama tanpa modul yang sedang diedit -> keterangan di bawah isian Modul.
export const modulBelumDipilih = (form, editing) =>
    form.role === "admin_koas" && !form.prodi_id && editing?.role === "admin_koas" && !editing?.prodi_id;

export const TEKS_MODUL_BELUM_DIPILIH = "Belum dipilih (melihat semua modul)";

// Isi kolom "Prodi / Modul / Instalasi" di daftar akun.
export function cakupanAkun(u, prodiMap, instalasiMap) {
    if (u.role === "admin_instalasi") return (u.instalasi_ids || []).map((id) => instalasiMap[id] || "?").join(", ") || "-";
    if (u.role === "admin_koas" && !u.prodi_id) return TEKS_MODUL_BELUM_DIPILIH;
    return prodiMap[u.prodi_id]?.nama_prodi || "-";
}

// Ganti peran di formulir: pilihan prodi/modul lama tidak relevan lagi (daftar Admin Prodi & Modul berbeda),
// kecuali kembali ke peran asli akun yang diedit.
export const prodiSetelahGantiPeran = (form, peranBaru, editing) =>
    peranBaru === form.role ? form.prodi_id : peranBaru === editing?.role ? editing?.prodi_id || "" : "";

// Pesan setelah akun disunting. Server memberi sesi_dicabut = true bila cakupan/hak akses akun itu berubah
// (ganti peran, prodi Admin Prodi, Modul Admin Koas, instalasi, nonaktif) -- semua sesinya keluar.
export const pesanAkunDiperbarui = (respons) =>
    respons?.sesi_dicabut ? "User diperbarui. Semua sesi akun ini keluar; pemiliknya perlu login ulang." : "User diperbarui";
